import "./SelectableList.scss";
import { useState } from "react";

const SelectableList = ({ data, onSelectItem }) => {
	const [selectedId, setSelectedId] = useState(null);

	const handleSelect = (item) => {
		if (item.type === "header") return; // Skip header clicks
		setSelectedId(item.Id);
		onSelectItem(item);
	};

	return (
		<div className="selectable-list">
			{data.map((item, index) => {
				if (item.type === "header") {
					return (
						<div key={`header-${index}`} className="selectable-list-header">
							<h4>{item.company}</h4>
						</div>
					);
				}

				const isSelected = selectedId === item.Id;

				return (
					<div
						key={item.Id}
						className={`selectable-list-item ${isSelected ? "selected" : ""}`}
						onClick={() => handleSelect(item)}
					>
						{/*Company*/}
						{item.Name && <p className="selectable-list-item-name">{item.Name}</p>}

						{/*User*/}
						<div className="selectable-list-item-name">
							{item.FullName && <>
								<p>{item.FullName}</p>
								{item.IsAdmin && (
									<div className="selectable-list-item-admin">
										<p>A</p>
									</div>
								)}
							</>}
						</div>

						{item.Email && <p className="selectable-list-item-email">({item.Email})</p>}
						
					</div>
				);
			})}
		</div>
	);
};

export default SelectableList;
